<template>
  <div class="company-show" style="height:788px;">
    <div class="company-show-inner">
      <h2 class="public-title public-title-white">文都风采</h2>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in companyShow" :key="index">
            <img style="width:100%;" :src="require('@/assets/images/img/'+item.imgSrc)" alt="">
            <p class="company-title">{{item.title}}</p>
          </div>
        </div>
        <div class="button wrap">
          <div class="swiper-button-prev"><img src="@/assets/images/icon/ic_prepage.png" alt=""></div>
          <div class="swiper-button-next"><img src="@/assets/images/icon/ic_nextpage.png" alt=""></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from "vue";
import Swiper from "swiper";
export default defineComponent({
  setup() {
      const swiperInd=ref(0) //默认中间那个  从1开始
    const companyShow = reactive([
      {
        imgSrc: "img_photo1.jpg",
        title: "学习氛围"
      },
      {
        imgSrc: "img_photo2.jpg",
        title: "企业面貌"
      },
      {
        imgSrc: "img_photo3.jpg",
        title: "讲座现场"
      },
      {
        imgSrc: "img_photo4.jpg",
        title: "办公环境"
      },
      {
        imgSrc: "img_photo5.jpg",
        title: "校区环境"
      },
      {
        imgSrc: "img_photo6.jpg",
        title: "小班教学"
      }
    ]);

    onMounted(() => {
      var swiper = new Swiper(".company-show .swiper-container", {
        autoplay: 5000,
        speed: 500,
        autoplayDisableOnInteraction: false,
        loop: true,
        centeredSlides: true,
        // slidesPerView: 2,
        slidesPerView: 'auto',
        paginationClickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        onInit: function(swiper) {
          swiper.slides[2].className = "swiper-slide swiper-slide-active"; //第一次打开不要动画
        },
        onlyExternal : true,
      });
    });
    return {
      companyShow,
      swiperInd
    };
  }
});
</script>

<style lang="scss" scoped type="text/scss">
.company-show {
  padding-bottom: 100px;
  background: #012138;

  .company-show-inner {
    max-width: 1920px;
    margin: 0 auto;
  }
  .cover-list {
    img {
      width: 100%;
    }
  }
  .company-title {
    color: #fff;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 24px;
    margin-top: 32px;
  }

  .swiper-slide {
    -webkit-transition: transform 1s;
    -moz-transition: transform 1s;
    -ms-transition: transform 1s;
    -o-transition: transform 1s;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);

    width:960px;
    .company-title {
      display: none;
    }
  }
  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    -webkit-transform: scale(1);
    transform: scale(1);
    .company-title {
      display: block;
    }
  }
  .swiper-slide-prev:after,
  .swiper-slide-next:after {
    position: absolute;
    left: 0;
    top: 0;
    content: "";
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
  .button {
    position: absolute;
    left: 50%;
    top: 44%;
    width: 100%;
    max-width:1320px;
    transform: translate(-50%, -50%);
    height: 100px;
    z-index: 3;
    img {
      width: 80px;
      height: 80px;
    }
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next,
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    background: none;
  }
  .swiper-button-next, .swiper-button-prev{
      width:80px;
      height:80px;
  }
  .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
    left:0;
  }
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev{
    right:0;
  }
}
</style>
